import React from 'react';
import { loanPerformanceData } from '../utils/mockData';
import ChartCard from '../components/dashboard/ChartCard';
const Loans: React.FC = () => {
  return <div className="space-y-6" data-id="element-1475">
      <div data-id="element-1476">
        <h1 className="text-2xl font-bold text-gray-900 dark:text-white" data-id="element-1477">
          Loan Discovery Administration
        </h1>
        <p className="mt-1 text-sm text-gray-500 dark:text-gray-400" data-id="element-1478">
          Manage loan partners, monitor applications, and track user trust
          scores.
        </p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-4 gap-6" data-id="element-1479">
        <div className="bg-white dark:bg-gray-800 rounded-lg shadow p-6" data-id="element-1480">
          <div className="text-sm font-medium text-gray-500 dark:text-gray-400" data-id="element-1481">
            Lender Partners
          </div>
          <div className="mt-2 text-3xl font-semibold text-gray-900 dark:text-white" data-id="element-1482">
            18
          </div>
        </div>
        <div className="bg-white dark:bg-gray-800 rounded-lg shadow p-6" data-id="element-1483">
          <div className="text-sm font-medium text-gray-500 dark:text-gray-400" data-id="element-1484">
            Applications Today
          </div>
          <div className="mt-2 text-3xl font-semibold text-gray-900 dark:text-white" data-id="element-1485">
            124
          </div>
        </div>
        <div className="bg-white dark:bg-gray-800 rounded-lg shadow p-6" data-id="element-1486">
          <div className="text-sm font-medium text-gray-500 dark:text-gray-400" data-id="element-1487">
            Approval Rate
          </div>
          <div className="mt-2 text-3xl font-semibold text-gray-900 dark:text-white" data-id="element-1488">
            68.2%
          </div>
        </div>
        <div className="bg-white dark:bg-gray-800 rounded-lg shadow p-6" data-id="element-1489">
          <div className="text-sm font-medium text-gray-500 dark:text-gray-400" data-id="element-1490">
            Revenue MTD
          </div>
          <div className="mt-2 text-3xl font-semibold text-gray-900 dark:text-white" data-id="element-1491">
            $15,480
          </div>
        </div>
      </div>
      <div className="grid grid-cols-1 gap-6" data-id="element-1492">
        <ChartCard title="Loan Performance" subtitle="Applications and approvals by loan type" data={loanPerformanceData} type="bar" dataKeys={['applications', 'approvals']} colors={['#3B82F6', '#10B981']} data-id="element-1493" />
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6" data-id="element-1494">
        <div className="bg-white dark:bg-gray-800 rounded-lg shadow p-6" data-id="element-1495">
          <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-4" data-id="element-1496">
            Trust Score Distribution
          </h3>
          <div className="space-y-4" data-id="element-1497">
            <div data-id="element-1498">
              <div className="flex justify-between text-sm mb-1" data-id="element-1499">
                <span className="text-gray-500 dark:text-gray-400" data-id="element-1500">
                  Excellent (800-850)
                </span>
                <span className="font-medium text-gray-700 dark:text-gray-200" data-id="element-1501">
                  12%
                </span>
              </div>
              <div className="w-full bg-gray-200 dark:bg-gray-600 rounded-full h-2.5" data-id="element-1502">
                <div className="bg-green-600 h-2.5 rounded-full" style={{
                width: '12%'
              }} data-id="element-1503"></div>
              </div>
            </div>
            <div data-id="element-1504">
              <div className="flex justify-between text-sm mb-1" data-id="element-1505">
                <span className="text-gray-500 dark:text-gray-400" data-id="element-1506">
                  Good (740-799)
                </span>
                <span className="font-medium text-gray-700 dark:text-gray-200" data-id="element-1507">
                  24%
                </span>
              </div>
              <div className="w-full bg-gray-200 dark:bg-gray-600 rounded-full h-2.5" data-id="element-1508">
                <div className="bg-green-500 h-2.5 rounded-full" style={{
                width: '24%'
              }} data-id="element-1509"></div>
              </div>
            </div>
            <div data-id="element-1510">
              <div className="flex justify-between text-sm mb-1" data-id="element-1511">
                <span className="text-gray-500 dark:text-gray-400" data-id="element-1512">
                  Average (670-739)
                </span>
                <span className="font-medium text-gray-700 dark:text-gray-200" data-id="element-1513">
                  38%
                </span>
              </div>
              <div className="w-full bg-gray-200 dark:bg-gray-600 rounded-full h-2.5" data-id="element-1514">
                <div className="bg-yellow-500 h-2.5 rounded-full" style={{
                width: '38%'
              }} data-id="element-1515"></div>
              </div>
            </div>
            <div data-id="element-1516">
              <div className="flex justify-between text-sm mb-1" data-id="element-1517">
                <span className="text-gray-500 dark:text-gray-400" data-id="element-1518">
                  Fair (580-669)
                </span>
                <span className="font-medium text-gray-700 dark:text-gray-200" data-id="element-1519">
                  18%
                </span>
              </div>
              <div className="w-full bg-gray-200 dark:bg-gray-600 rounded-full h-2.5" data-id="element-1520">
                <div className="bg-orange-500 h-2.5 rounded-full" style={{
                width: '18%'
              }} data-id="element-1521"></div>
              </div>
            </div>
            <div data-id="element-1522">
              <div className="flex justify-between text-sm mb-1" data-id="element-1523">
                <span className="text-gray-500 dark:text-gray-400" data-id="element-1524">
                  Poor (300-579)
                </span>
                <span className="font-medium text-gray-700 dark:text-gray-200" data-id="element-1525">
                  8%
                </span>
              </div>
              <div className="w-full bg-gray-200 dark:bg-gray-600 rounded-full h-2.5" data-id="element-1526">
                <div className="bg-red-500 h-2.5 rounded-full" style={{
                width: '8%'
              }} data-id="element-1527"></div>
              </div>
            </div>
          </div>
        </div>
        <div className="bg-white dark:bg-gray-800 rounded-lg shadow p-6" data-id="element-1528">
          <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-4" data-id="element-1529">
            Recent Applications
          </h3>
          <div className="overflow-y-auto max-h-[300px]" data-id="element-1530">
            <table className="min-w-full divide-y divide-gray-200 dark:divide-gray-700" data-id="element-1531">
              <thead className="bg-gray-50 dark:bg-gray-700" data-id="element-1532">
                <tr data-id="element-1533">
                  <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider" data-id="element-1534">
                    User
                  </th>
                  <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider" data-id="element-1535">
                    Loan Type
                  </th>
                  <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider" data-id="element-1536">
                    Amount
                  </th>
                  <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider" data-id="element-1537">
                    Status
                  </th>
                </tr>
              </thead>
              <tbody className="bg-white dark:bg-gray-800 divide-y divide-gray-200 dark:divide-gray-700" data-id="element-1538">
                <tr data-id="element-1539">
                  <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900 dark:text-white" data-id="element-1540">
                    John D.
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 dark:text-gray-400" data-id="element-1541">
                    Personal Loan
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 dark:text-gray-400" data-id="element-1542">
                    $15,000
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-1543">
                    <span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200" data-id="element-1544">
                      Approved
                    </span>
                  </td>
                </tr>
                <tr data-id="element-1545">
                  <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900 dark:text-white" data-id="element-1546">
                    Sarah M.
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 dark:text-gray-400" data-id="element-1547">
                    Auto Loan
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 dark:text-gray-400" data-id="element-1548">
                    $28,500
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-1549">
                    <span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-yellow-100 text-yellow-800 dark:bg-yellow-900 dark:text-yellow-200" data-id="element-1550">
                      Pending
                    </span>
                  </td>
                </tr>
                <tr data-id="element-1551">
                  <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900 dark:text-white" data-id="element-1552">
                    Robert J.
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 dark:text-gray-400" data-id="element-1553">
                    Mortgage
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 dark:text-gray-400" data-id="element-1554">
                    $320,000
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-1555">
                    <span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-200" data-id="element-1556">
                      Declined
                    </span>
                  </td>
                </tr>
                <tr data-id="element-1557">
                  <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900 dark:text-white" data-id="element-1558">
                    Emily D.
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 dark:text-gray-400" data-id="element-1559">
                    Student Loan
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 dark:text-gray-400" data-id="element-1560">
                    $45,000
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-1561">
                    <span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200" data-id="element-1562">
                      Approved
                    </span>
                  </td>
                </tr>
                <tr data-id="element-1563">
                  <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900 dark:text-white" data-id="element-1564">
                    Michael W.
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 dark:text-gray-400" data-id="element-1565">
                    Personal Loan
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 dark:text-gray-400" data-id="element-1566">
                    $8,000
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-1567">
                    <span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-yellow-100 text-yellow-800 dark:bg-yellow-900 dark:text-yellow-200" data-id="element-1568">
                      Pending
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div className="bg-white dark:bg-gray-800 shadow rounded-lg overflow-hidden" data-id="element-1569">
        <div className="p-6 border-b border-gray-200 dark:border-gray-700" data-id="element-1570">
          <h3 className="text-lg font-medium text-gray-900 dark:text-white" data-id="element-1571">
            Lender Partners
          </h3>
        </div>
        <div className="overflow-x-auto" data-id="element-1572">
          <table className="min-w-full divide-y divide-gray-200 dark:divide-gray-700" data-id="element-1573">
            <thead className="bg-gray-50 dark:bg-gray-700" data-id="element-1574">
              <tr data-id="element-1575">
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider" data-id="element-1576">
                  Lender
                </th>
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider" data-id="element-1577">
                  Loan Types
                </th>
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider" data-id="element-1578">
                  Min Credit Score
                </th>
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider" data-id="element-1579">
                  Approval Rate
                </th>
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider" data-id="element-1580">
                  Status
                </th>
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider" data-id="element-1581">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody className="bg-white dark:bg-gray-800 divide-y divide-gray-200 dark:divide-gray-700" data-id="element-1582">
              <tr className="hover:bg-gray-50 dark:hover:bg-gray-700" data-id="element-1583">
                <td className="px-6 py-4 whitespace-nowrap" data-id="element-1584">
                  <div className="flex items-center" data-id="element-1585">
                    <div className="flex-shrink-0 h-10 w-10 rounded-full bg-blue-100 flex items-center justify-center text-blue-600" data-id="element-1586">
                      LC
                    </div>
                    <div className="ml-4" data-id="element-1587">
                      <div className="text-sm font-medium text-gray-900 dark:text-white" data-id="element-1588">
                        LendingClub
                      </div>
                    </div>
                  </div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 dark:text-gray-400" data-id="element-1589">
                  Personal, Business
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 dark:text-gray-400" data-id="element-1590">
                  660
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 dark:text-gray-400" data-id="element-1591">
                  72.4%
                </td>
                <td className="px-6 py-4 whitespace-nowrap" data-id="element-1592">
                  <span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200" data-id="element-1593">
                    Active
                  </span>
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm font-medium" data-id="element-1594">
                  <button className="text-blue-600 hover:text-blue-900 dark:text-blue-400 dark:hover:text-blue-300" data-id="element-1595">
                    View
                  </button>
                </td>
              </tr>
              <tr className="hover:bg-gray-50 dark:hover:bg-gray-700" data-id="element-1596">
                <td className="px-6 py-4 whitespace-nowrap" data-id="element-1597">
                  <div className="flex items-center" data-id="element-1598">
                    <div className="flex-shrink-0 h-10 w-10 rounded-full bg-green-100 flex items-center justify-center text-green-600" data-id="element-1599">
                      SL
                    </div>
                    <div className="ml-4" data-id="element-1600">
                      <div className="text-sm font-medium text-gray-900 dark:text-white" data-id="element-1601">
                        SoFi Lending
                      </div>
                    </div>
                  </div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 dark:text-gray-400" data-id="element-1602">
                  Student, Personal, Mortgage
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 dark:text-gray-400" data-id="element-1603">
                  680
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 dark:text-gray-400" data-id="element-1604">
                  68.9%
                </td>
                <td className="px-6 py-4 whitespace-nowrap" data-id="element-1605">
                  <span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200" data-id="element-1606">
                    Active
                  </span>
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm font-medium" data-id="element-1607">
                  <button className="text-blue-600 hover:text-blue-900 dark:text-blue-400 dark:hover:text-blue-300" data-id="element-1608">
                    View
                  </button>
                </td>
              </tr>
              <tr className="hover:bg-gray-50 dark:hover:bg-gray-700" data-id="element-1609">
                <td className="px-6 py-4 whitespace-nowrap" data-id="element-1610">
                  <div className="flex items-center" data-id="element-1611">
                    <div className="flex-shrink-0 h-10 w-10 rounded-full bg-purple-100 flex items-center justify-center text-purple-600" data-id="element-1612">
                      MC
                    </div>
                    <div className="ml-4" data-id="element-1613">
                      <div className="text-sm font-medium text-gray-900 dark:text-white" data-id="element-1614">
                        Marcus
                      </div>
                    </div>
                  </div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 dark:text-gray-400" data-id="element-1615">
                  Personal, Debt Consolidation
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 dark:text-gray-400" data-id="element-1616">
                  720
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 dark:text-gray-400" data-id="element-1617">
                  75.2%
                </td>
                <td className="px-6 py-4 whitespace-nowrap" data-id="element-1618">
                  <span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200" data-id="element-1619">
                    Active
                  </span>
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm font-medium" data-id="element-1620">
                  <button className="text-blue-600 hover:text-blue-900 dark:text-blue-400 dark:hover:text-blue-300" data-id="element-1621">
                    View
                  </button>
                </td>
              </tr>
              <tr className="hover:bg-gray-50 dark:hover:bg-gray-700" data-id="element-1622">
                <td className="px-6 py-4 whitespace-nowrap" data-id="element-1623">
                  <div className="flex items-center" data-id="element-1624">
                    <div className="flex-shrink-0 h-10 w-10 rounded-full bg-red-100 flex items-center justify-center text-red-600" data-id="element-1625">
                      LD
                    </div>
                    <div className="ml-4" data-id="element-1626">
                      <div className="text-sm font-medium text-gray-900 dark:text-white" data-id="element-1627">
                        LendingDirect
                      </div>
                    </div>
                  </div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 dark:text-gray-400" data-id="element-1628">
                  Auto, Personal
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 dark:text-gray-400" data-id="element-1629">
                  640
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 dark:text-gray-400" data-id="element-1630">
                  62.8%
                </td>
                <td className="px-6 py-4 whitespace-nowrap" data-id="element-1631">
                  <span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-yellow-100 text-yellow-800 dark:bg-yellow-900 dark:text-yellow-200" data-id="element-1632">
                    Under Review
                  </span>
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm font-medium" data-id="element-1633">
                  <button className="text-blue-600 hover:text-blue-900 dark:text-blue-400 dark:hover:text-blue-300" data-id="element-1634">
                    View
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>;
};
export default Loans;